<template>
  <div
    ref="partialDiv"
    :class="{
      'container mx-auto': true,
    }"
  >
    <div
      :class="{
        'uss-error-out mt-6': true,
      }"
    >
      <div
        :class="{
          'text-center text-xl font-semibold leading-9 text-www-color-neutral-medium-dark md:text-2xl md:leading-[2.6875rem] lg:text-5xl lg:leading-[5.4rem]': true,
        }"
      >
        {{ title }}
      </div>
      <component
        :is="getComponent(subtitle._type)"
        v-if="subtitle && subtitle._type"
        :value="subtitle"
        :class="{
          'my-6': true,
        }"
      />
    </div>

    <template v-if="screenPartialData?.sectionBuilder?.length > 0">
      <component
        :is="getComponent(component._type)"
        v-for="component in screenPartialData?.sectionBuilder"
        :key="component._key"
        :value="component"
      />
    </template>
  </div>
</template>

<script lang="ts" setup>
import { FieldHtmlNameUtil } from '@onshape/www-inertia';
import { getComponent } from '~/components/Mapper';
import type UnifiedSignupSessionInfo from '~/hekate-www/external/facets/Form/coordinator/UnifiedSignup/session-info/UnifiedSignupSessionInfo';
import type EmailCheck500SignupScreen from '~/hekate-www/external/facets/Form/coordinator/UnifiedSignup/screens/EmailCheck500SignupScreen';
import type { SignupPartialViewsSectionBuilder, UssSuccessRedirect } from '~/sanity/types';
import UnifiedSignupStartScreen from '~/hekate-www/external/facets/Form/coordinator/UnifiedSignup/session-info/UnifiedSignupStartScreen';
import RedirectUtil from '~/hekate-www/external/util/RedirectUtil';
import AntiSpamUtil from '~/hekate-www/external/util/AntiSpamUtil';

const props = defineProps<
  UssSuccessRedirect & {
    signupScreen: EmailCheck500SignupScreen;
    sessionInfo: UnifiedSignupSessionInfo;
    screenPartialData: SignupPartialViewsSectionBuilder;
  }
>();

const partialDiv = ref<HTMLDivElement | null>(null);

onMounted(() => {
  // Handle buyStandard redirect
  if (props.sessionInfo.startScreen.compareTo(UnifiedSignupStartScreen.buyStandard)) {
    partialDiv.value?.classList.add('d-none');
    RedirectUtil.redirectTo({
      delay: 0,
      target: props.signupScreen.getField(FieldHtmlNameUtil.signupRedirectUrl).val as string,
    });
    return;
  }

  // Perform CSRF token test for anti-spam protection
  AntiSpamUtil.csrfTokenTest({ hint: 'signup-500-screen' });
});
</script>

<style></style>
